import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

const EvolutionIconContainer = styled.div`
  width: 16px;
  height: 16px
  min-width:16px;
  min-height:16px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.icon === 'positive' || props.icon === 'up' || props.icon === 'check'
      ? 'rgba(108,200,159,0.2)'
      : props.icon === 'negative' ||
          props.icon === 'down' ||
          props.icon === 'close'
        ? 'rgba(211,86,54,0.2)'
        : props.theme.colors['dark-two-opa20']};
  color: black;
`;

const EvolutionIcon = ({ icon }) => (
  <EvolutionIconContainer icon={icon}>
    <Icon icon={`${icon}Evolution`} />
  </EvolutionIconContainer>
);

export default EvolutionIcon;
